import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loader: true,
    message: {
      text: '',
      type: 'info', // info success error
    }
  },
  mutations: {
    // 更新状态
    updateLoader (state, val) {
      state.loader = val ? true : false
    },
    updateMessage (state, {text = '', type = 'info'}) {
      state.message = {
        text: text,
        type: type
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
